import React, { ReactNode } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Row, Col } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import Dropdown from "components/atoms/Dropdown/Dropdown";
import NOTIFICATION_OPTIONS from "../../options";

interface SettingProps {
  titleId: string;
  name: string;
  children: ReactNode;
}

function Setting({ titleId, name, children }: SettingProps) {
  const intl = useIntl();
  const { watch } = useFormContext();
  return (
    <Row className="mb-3">
      <Col sm={3}>
        <h6>
          <FormattedMessage id={titleId} />
        </h6>
      </Col>
      <Col sm={9}>
        <Dropdown useHookForm name={`settings.${name}`} options={NOTIFICATION_OPTIONS(intl)} className="w-192" />
        {watch(`settings.${name}`) === "custom" && <>{children}</>}
      </Col>
    </Row>
  );
}

export default Setting;
